import React from 'react'
import { PCCCategories, PCCCategoryIds } from '_constants'
import { PatientCategoryTab } from 'PatientCareCenter/Home'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux';
import { patientActions } from '_actions';

class PatientCategoryList extends React.Component {

    changeCategory(categoryId) {
        if (categoryId === PCCCategoryIds.DIARY && this.props.pacDeepLink) {
            window.open(this.props.pacDeepLink, '_blank');
            return;
        }
        this.props.changeCategory({ ptno: this.props.ptno, selectedHomeCategory: categoryId });
    }


    render() {
        const list = PCCCategories.map((category) => {
            return (
                <PatientCategoryTab
                    key={category.id}
                    categoryId={category.id}
                    name={category.id === PCCCategoryIds.DIARY && this.props.pacDeepLink ? 'Patient Action Center' : category.name}
                    ptno={this.props.ptno}
                    changeCategory={() => this.changeCategory(category.id)}
                    selected={this.props.selectedHomeCategory === category.id ? true : false} />
            );
        });

        return (
            <div>
                {list}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        changeCategory: bindActionCreators(patientActions.categoryChange, dispatch)
    };
}

function mapStateToProps(state) {
    let patient = state.entities.patients[state.ui.patients.selectedPtno]
    let pacDeepLink = patient.pacDeepLink;

    return {
        selectedHomeCategory: state.ui.patientCenter[state.ui.patients.selectedPtno].selectedHomeCategory,
        ptno: state.ui.patients.selectedPtno,
        pacDeepLink
    };
}

const connectedPatientCategoryList = connect(mapStateToProps, mapDispatchToProps)(PatientCategoryList);
export { connectedPatientCategoryList as PatientCategoryList };
